import { RenderItemProps, VirtualList } from '@shared/components/ui/VirtualList';
import { useTranslation } from 'react-i18next';
import { PackingStation, type PackingStationRelationsTabKey } from '../../models/PackingStation';
import { PackingStationCard } from './PackingStationCard';

interface PackingStationCardListProps {
  packingStations: PackingStation[];
  fetchNextPage?: () => void;
  hasNextPage?: boolean;
  isFetchingNextPage?: boolean;
  onOpenDetail?: (station: PackingStation, tab?: PackingStationRelationsTabKey) => void;
  onOpenEdit?: (station: PackingStation) => void;
  onPrint?: (station: PackingStation, size: 'small' | 'large') => void;
  refetch?: () => void;
}

export const PackingStationCardList = ({
  packingStations,
  fetchNextPage,
  hasNextPage = false,
  isFetchingNextPage = false,
  onOpenDetail,
  onOpenEdit,
  onPrint,
  refetch,
}: PackingStationCardListProps) => {
  const { t } = useTranslation('packingStationsModule');

  const renderCard = (props: RenderItemProps<PackingStation>) => (
    <PackingStationCard
      {...props}
      onOpenDetail={onOpenDetail}
      onOpenEdit={onOpenEdit}
      onPrint={onPrint}
      refetch={refetch}
    />
  );

  return (
    <VirtualList
      data={packingStations}
      renderItem={renderCard}
      itemKey={(item) => item.id}
      estimateItemHeight={150}
      height="calc(100vh - 180px)"
      gap={0}
      emptyMessage={t('empty.description')}
      className="rounded-lg shadow-sm"
      fetchNextPage={fetchNextPage}
      hasNextPage={hasNextPage}
      isFetchingNextPage={isFetchingNextPage}
      infiniteScrollThreshold={280}
      listClassName="touch-pan-y"
      itemClassName="touch-manipulation"
    />
  );
};
